import axios, { isAxiosError } from 'axios';
import { CredsystemLocalStorage } from '~/credsystem/storage/LocalStorage';
import { CREDSYSTEM_APP_UID } from '~/credsystem/storage/constants';
import Env from '~/credsystem/env';
import { MarisaAppUtils } from '~/utils/MarisaAppUtils';

const CREDSYSTEM_CLIENT_SESSION_API_BASE_URL = `https://${Env.CREDSYSTEM_CLIENT_SESSION_API}`;

interface ValidatesCredSystemFirstAccessParams {
  document: string;
  password: string;
}

interface APISuccessResponse {
  httpStatusCode: number;
  data: {
    atualizaApp: boolean;
    access_token: string;
    expires_in: number;
  };
}

interface APIErrorResponse {
  httpStatusCode: 400;
  data: {
    retorno: {
      codigo: string;
      titulo: string;
      mensagem: string;
      validou: boolean;
    };
    atualizaApp: boolean;
  };
}

type APIResponse = APISuccessResponse & APIErrorResponse;

export async function validatesCredSystemFirstAccessUseCase({
  document,
  password,
}: ValidatesCredSystemFirstAccessParams): Promise<APIResponse | null> {
  const deviceInfo = {
    dispositivoId:
      MarisaAppUtils.origin === 'app'
        ? MarisaAppUtils.deviceId
        : await CredsystemLocalStorage.get(CREDSYSTEM_APP_UID),
    idSistemaOperacional: MarisaAppUtils.OSId,
    versaoSistemaOperacional: MarisaAppUtils.OSVersion,
    modelo: MarisaAppUtils.deviceModel,
    versaoApp: '99999999',
  };

  // const deviceInfo = {
  //   dispositivoId: '29',
  //   idSistemaOperacional: deviceInfoModule.getSystemName(),
  //   versaoSistemaOperacional: deviceInfoModule.getSystemVersion(),
  //   modelo: deviceInfoModule.getModel(),
  //   versaoApp: '99999999',
  // };

  try {
    const response = await axios.post<APIResponse>(
      `${CREDSYSTEM_CLIENT_SESSION_API_BASE_URL}/api/v1/identificacao/dados`,
      {
        app: 'APP_MARISA',
        fluxo: 'PRIMEIRO_ACESSO',
        cliente: {
          cpf: document,
          dataNascimento: password,
        },
        dispositivo: deviceInfo,
      }
    );

    return response?.data;
  } catch (error) {
    if (isAxiosError(error))
      return {
        httpStatusCode: error.response?.status,
        ...error.response?.data,
      };

    return null;
  }
}
